import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useContainer } from './hooks/useContainer.js';

var _excluded = ["children"];
var Container = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useContainer = useContainer(restProps, ref),
    outerContainerProps = _useContainer.outerContainerProps,
    innerContainerProps = _useContainer.innerContainerProps;
  return /*#__PURE__*/React.createElement("div", outerContainerProps, /*#__PURE__*/React.createElement("div", innerContainerProps, children));
});

export { Container };
//# sourceMappingURL=Container.js.map
